export const TOOLTIP_BUILDER_WP = 'tooltip_builder_welcome-page';
